import { styled } from '@mui/system';
import { Box, IconButton, Button } from '@mui/material';

export const ModalBox = styled(Box)({
  position: 'absolute',
  top: '0',
  left: '0',
  width: '100%',
  height: '100%',
  backgroundColor: '#fff',
  boxShadow: '0px 11px 15px -7px rgba(0,0,0,0.2),0px 24px 38px 3px rgba(0,0,0,0.14),0px 9px 46px 8px rgba(0,0,0,0.12)',
  padding: 32,
  overflow: 'auto'
});

export const CloseButton = styled(IconButton)({
  position: 'absolute',
  top: '10px',
  right: '10px'
});

export const ApplianceItemButton = styled(Button)({
  display: 'block',
  marginBottom: '10px'
});
